import Vue from 'vue'
import VueResource from 'vue-resource'  
import App from './App.vue'
import bus from './common/bus'
import moment from 'moment'  
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(VueResource)

Vue.http.interceptors.push(function(request, next) {
    // modify request
  
    if(typeof(bus.login.authBearer) != 'undefined'){
      request.headers.set('Authorization', 'Bearer ' + bus.login.authBearer);
    }
    //console.log(JSON.stringify(request.url, null, 2));

  
  next(function(response) {
    if(response.status == 0){
      // net::ERR_CONNECTION_TIMED_OUT -> don't logout
      console.error('interceptor.response.status == 0, Date: ' + moment().format());
      console.log(JSON.stringify(request, null, 2));
      console.log(JSON.stringify(response, null, 2));
      
    }
    else if(response.status != 200){
      bus.logout('logout by interceptor: status != 200');
      console.error('logout because interceptor.response.status != 200, status:  ' + response.status + ', Date: ' + moment().format());
      console.log(JSON.stringify(response, null, 2));
      console.log(JSON.stringify(request, null, 2));
    }

  });
});

Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})

const app = new Vue({
  el: '#app',
  render: h => h(App),

})




// WEBPACK FOOTER //
// ./src/main.js